import React, { useState } from "react";
import "./CTASection.css";
import { useLoader } from "../../context/LoaderProvider";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const CTASection = ({ isOpen, onClose, }) => {
 
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const { showLoader, hideLoader } = useLoader();
    const navigate = useNavigate();
    const [vendorData, setVendorData] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        companyName: "",
        email: "",
        phone: "",
        city: "",
        businessVerticals: "FOOD_AND_BEVERAGES", // Add this field with default value
    });

    const businessVerticalsOptions = [
        { value: "FOOD_AND_BEVERAGES", label: "Food & Beverages" },
        { value: "CATERINGS_SERVICES", label: "Catering Services" },
        { value: "LOGISTICS_SUPPLY", label: "Logistics & Supply" },
        { value: "FRESH_GROCERIES", label: "Fresh Groceries" },
        { value: "ENGINEERING_SERVICE", label: "Engineering Service" }
    ];

    const [loginObj, setLoginObj] = useState({
        emailId: ""
    });

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const openLoginModal = () => setIsLoginModalOpen(true);
    const closeLoginModal = () => setIsLoginModalOpen(false);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleChange = (e) => {
        setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
    };
    // Add this state
    const [testLoader, setTestLoader] = useState(false);

    // Add this test function
    const testLoaderAfterDelay = () => {
        setTestLoader(true);
        showLoader();

        setTimeout(() => {
            hideLoader();
            setTestLoader(false);
            // alert("Loader test completed - 5 seconds passed");
        }, 5000);
    };

    const showCustomAlert = (msg) => alert(msg);

    // ✅ ENQUIRY SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // ================= ✅ VALIDATIONS =================

            if (!formData.name || !formData.email || !formData.phone || !formData.city) {
                showCustomAlert("Please fill all required fields");
                return;
            }

            if (!formData.businessVerticals) {
                showCustomAlert("Please select a business vertical");
                return;
            }

            const name = formData.name.trim();
            if (name.length < 2) {
                showCustomAlert("Name must be at least 2 characters");
                return;
            }
            if (!/^[a-zA-Z\s]+$/.test(name)) {
                showCustomAlert("Name should contain only letters");
                return;
            }

            const email = formData.email.trim();
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|org|net)$/;
            if (!emailRegex.test(email)) {
                showCustomAlert("Enter valid email (example@gmail.com)");
                return;
            }

            const phone = formData.phone.replace(/\D/g, "");
            if (!/^[0-9]{10}$/.test(phone)) {
                showCustomAlert("Enter valid 10-digit phone number");
                return;
            }

            const city = formData.city.trim();
            if (city.length < 2) {
                showCustomAlert("Enter valid city");
                return;
            }

            // ================= ✅ PAYLOAD =================
            const currentDateTime = new Date().toISOString();

            const payload = {
                vendorId: vendorData?.vendorId || 0,
                parentId: null,
                name,
                email,
                city,
                mobileNumber: phone,
                companyName: formData.companyName?.trim() || "",
                role: "ROLE_VENDOR",
                registerTime: currentDateTime,
                businessVerticals: [formData.businessVerticals],
            };

            closeModal();
            showLoader();

            // ================= ✅ API CALL =================
            const res = await fetch(
                "https://backend.maamaas.com/subscription/api/vendor/enquiry",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const responseText = await res.text();
            let responseData = {};

            try {
                responseData = responseText ? JSON.parse(responseText) : {};
            } catch { }

            // ================= ❌ ERROR HANDLING =================
            if (!res.ok) {
                const msg = (responseData.message || responseText || "").toLowerCase();

                if (msg.includes("email") && msg.includes("exist")) {
                    showCustomAlert("❌ Email already exists");
                } else if (msg.includes("mobile") || msg.includes("phone")) {
                    showCustomAlert("❌ Phone number already exists");
                } else {
                    showCustomAlert("❌ Something went wrong");
                }
                return;
            }

            // ================= ✅ STORE DATA =================

            if (responseData.vendorId) {
                localStorage.setItem("vendorId", responseData.vendorId);
            } else {
                // console.log("❌ [ERROR] vendorId not found in response");
            }

            if (responseData.referenceId) {
                localStorage.setItem("customerId", responseData.referenceId);
            }

            // 🔥 STORE BUSINESS VERTICAL (IMPORTANT FIX)
            localStorage.setItem("businessVertical", formData.businessVerticals);

            localStorage.setItem("vendorBusinessVerticals", JSON.stringify([formData.businessVerticals]));

            // 🔥 STORE FULL DATA (BEST PRACTICE)
            localStorage.setItem(
                "vendorData",
                JSON.stringify({
                    ...responseData,
                    businessVerticals: [formData.businessVerticals],
                    name,
                    email,
                    mobileNumber: phone,
                    city,
                })
            );

            // Optional user info
            localStorage.setItem("userName", name);
            localStorage.setItem("userEmail", email);
            localStorage.setItem("userPhone", phone);
            localStorage.setItem("userCity", city);

         

            // ================= ✅ RESET =================
            setFormData({
                name: "",
                companyName: "",
                email: "",
                phone: "",
                city: "",
                businessVerticals: "FOOD_AND_BEVERAGES",
            });

            // 🚀 Navigate
            navigate("/demo-dashboard");

        } catch (err) {
            if (err.message?.toLowerCase().includes("network")) {
                showCustomAlert("Network error. Check connection");
            } else {
                showCustomAlert("Something went wrong");
            }
        } finally {
            hideLoader();
        }
    };

    // ✅ LOGIN EMAIL CHECK
    const handleEmailCheck = async (e) => {
        e.preventDefault();
        const email = loginObj.emailId?.trim();

        if (!email) {
            alert("Enter email");
            return;
        }

        showLoader();

        try {
            const response = await axios.get(
                "https://backend.maamaas.com/subscription/api/vendor/enquiry/get-email",
                { params: { emailId: email } }
            );

            const vendorData = response.data;

            if (vendorData?.vendorId) {

                // ✅ Store vendorId
                localStorage.setItem("vendorId", vendorData.vendorId);

                // ✅ Store full vendor data
                localStorage.setItem("vendorData", JSON.stringify(vendorData));

                // ✅ Handle business verticals
                let businessVertical = "";

                if (vendorData?.businessVerticals?.length > 0) {
                    businessVertical = vendorData.businessVerticals[0];

                    localStorage.setItem(
                        "vendorBusinessVerticals",
                        JSON.stringify(vendorData.businessVerticals)
                    );

                    localStorage.setItem("businessVertical", businessVertical);
                }

                // ✅ Show alert (🔥 THIS IS WHAT YOU WANT)
                alert(`Business Vertical: ${businessVertical}`);

                // ✅ Store referenceId
                if (vendorData?.referenceId) {
                    localStorage.setItem("customerId", vendorData.referenceId);
                }

                // Optional
                localStorage.setItem("vendorName", vendorData.name);
                localStorage.setItem("vendorEmail", vendorData.email);
                localStorage.setItem("vendorMobile", vendorData.mobileNumber);

                // 🚀 Navigate
                navigate("/demo-dashboard");

            } else {
                alert("Vendor not found");
            }

        } catch (err) {
            console.error(err);
            alert("Error checking email");
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="cta-container">




            {isOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "30px 25px",
                            borderRadius: "12px",
                            width: "350px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                            position: "relative",
                            animation: "fadeIn 0.3s ease",
                        }}
                    >
                        <button
                            onClick={onClose}
                            style={{
                                position: "absolute",
                                right: "12px",
                                top: "10px",
                                border: "none",
                                background: "none",
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#000"
                            }}
                        >
                            ×
                        </button>

                        <h3
                            style={{
                                textAlign: "center",
                                marginBottom: "20px",
                                color: "#333",
                                fontWeight: "600",
                            }}
                        >
                            Book  Demo
                        </h3>

                        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            <input
                                name="name"
                                placeholder="Name *"
                                onChange={handleInputChange}
                                style={{ padding: "10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "14px", color: "#000" }}
                                required
                            />
                            <input
                                name="companyName"
                                placeholder="Company Name"
                                onChange={handleInputChange}
                                style={{ padding: "10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "14px", color: "#000" }}
                            />
                            <input
                                name="email"
                                placeholder="Email *"
                                type="email"
                                onChange={handleInputChange}
                                style={{ padding: "10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "14px", color: "#000" }}
                                required
                            />
                            <input
                                name="phone"
                                placeholder="Phone *"
                                type="tel"
                                onChange={handleInputChange}
                                style={{ padding: "10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "14px", color: "#000" }}
                                required
                            />
                            <input
                                name="city"
                                placeholder="City *"
                                onChange={handleInputChange}
                                style={{ padding: "10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "14px", color: "#000" }}
                                required
                            />

                            {/* Business Verticals Dropdown */}
                            <select
                                name="businessVerticals"
                                value={formData.businessVerticals}
                                onChange={handleInputChange}
                                style={{
                                    padding: "10px",
                                    borderRadius: "6px",
                                    border: "2px solid #e0e0e0",  // ← Change from #ccc to light gray
                                    fontSize: "14px",
                                    color: "#000",
                                    backgroundColor: "#fff",
                                    cursor: "pointer",
                                    outline: "none",  // ← Remove default focus outline
                                    transition: "all 0.3s ease"
                                }}
                                onFocus={(e) => e.target.style.borderColor = "#e66d33"}
                                onBlur={(e) => e.target.style.borderColor = "#e0e0e0"}
                                required
                            >
                                {businessVerticalsOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                            {/* LOGIN SWITCH */}
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px", marginTop: "10px" }}>
                                <p style={{ fontSize: "13px", color: "#666", margin: 0 }}>Already have an account?</p>
                                <button
                                    type="button"
                                    onClick={() => {
                                        closeModal();
                                        openLoginModal();
                                    }}
                                    style={{ color: "#ff4d2d", background: "none", border: "none", cursor: "pointer", fontWeight: "600", fontSize: "13px", padding: 0 }}
                                >
                                    Login here
                                </button>
                            </div>

                            <button
                                type="submit"
                                style={{
                                    marginTop: "10px",
                                    padding: "12px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "linear-gradient(90deg, #ff4d2d, #ff6a3d)",
                                    color: "#fff",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                }}
                            >
                                Explore
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* 🔵 LOGIN MODAL */}
            {isLoginModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                        backdropFilter: "blur(4px)",
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "35px 25px",
                            borderRadius: "14px",
                            width: "340px",
                            boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
                            position: "relative",
                            animation: "fadeIn 0.3s ease",
                        }}
                    >
                        {/* CLOSE BUTTON */}
                        <button
                            onClick={closeLoginModal}
                            style={{
                                position: "absolute",
                                right: "12px",
                                top: "10px",
                                border: "none",
                                background: "none",
                                fontSize: "22px",
                                cursor: "pointer",
                                color: "#555",
                            }}
                        >
                            ×
                        </button>

                        {/* HEADER */}
                        <h3
                            style={{
                                textAlign: "center",
                                marginBottom: "5px",
                                color: "#2a0947",
                                fontWeight: "700",
                                fontSize: "20px",
                            }}
                        >
                            Welcome Back 👋
                        </h3>

                        <p
                            style={{
                                textAlign: "center",
                                fontSize: "13px",
                                color: "#777",
                                marginBottom: "20px",
                            }}
                        >
                            Login with your registered email
                        </p>

                        {/* FORM */}
                        <form
                            onSubmit={handleEmailCheck}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "14px",
                            }}
                        >
                            <input
                                type="email"
                                name="emailId"
                                placeholder="Enter your Email"
                                onChange={handleChange}
                                required
                                style={{
                                    padding: "12px",
                                    borderRadius: "8px",
                                    border: "1px solid #ddd",
                                    fontSize: "14px",
                                    outline: "none",
                                    transition: "0.3s",
                                    color: "#000"
                                }}
                                onFocus={(e) =>
                                    (e.target.style.border = "1px solid #ff4d2d")
                                }
                                onBlur={(e) =>
                                    (e.target.style.border = "1px solid #ddd")
                                }
                            />

                            <button
                                type="submit"
                                style={{
                                    padding: "12px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: "linear-gradient(90deg, #e66d33, #e66d33)",
                                    color: "#fff",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    transition: "0.3s",
                                }}
                                onMouseOver={(e) =>
                                    (e.target.style.opacity = "0.9")
                                }
                                onMouseOut={(e) =>
                                    (e.target.style.opacity = "1")
                                }
                            >
                                Check & Continue →
                            </button>
                        </form>


                    </div>
                </div>
            )}

        </div>
    );
};

export default CTASection;